//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { library } from '@fortawesome/fontawesome-svg-core';
import { faTags } from '@fortawesome/pro-regular-svg-icons';

library.add(faTags);

export default {
  name: 'CategoryTopics',
  components: {
    SectionHeader: () => import('@/components/landing/SectionHeader.vue'),
  },
  props: {
    topics: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    displayTopics() {
      const list = Array.isArray(this.topics) ? this.topics : [];
      return list.filter((d) => Boolean(_.get(d, 'url', '') || _.get(d, 'html.url', '')));
    },
  },
  methods: {
    topicKey(topic) {
      return _.get(topic, 'id', '') || _.get(topic, 'url', '') || this.topicHeading(topic);
    },
    topicHeading(topic) {
      return _.get(topic, 'heading', '') || '';
    },
    topicSubheadingLine(topic) {
      const raw = _.get(topic, 'subheading', '');
      if (raw == null || typeof raw !== 'string') return '';
      return raw.replace(/<[^>]+>/g, '').trim();
    },
    topicTo(topic) {
      const url = _.get(topic, 'url', '') || _.get(topic, 'html.url', '');
      if (!url) return '';
      try {
        return url.startsWith('/') ? this.$link(url).fullPath() : this.$link(new URL(url).pathname).fullPath();
      } catch {
        return url;
      }
    },
  },
};
